module.exports = __webpack_public_path__ + "static/media/Delivered.263c8ef0.gif";